import React from 'react';
import { Section, PageList } from 'components/travelsafe';
import { Spacer, Divider } from '@cleartrip/bento';

function SectionBlock({ section, index, sectionsLength, ...otherProps }) {
	return (
		<>
			<Section id={section.id} key={index} {...otherProps}>
				<Section.Title timeStamp={section.timestamp}>{section.title}</Section.Title>
				<Spacer className='pt-2' />
				{section.description && (
					<Section.Description dangerouslySetInnerHTML={{ __html: section.description }}></Section.Description>
				)}
				{section.lists && (
					<>
						<PageList
							lists={section.lists}
							initListCount={5}
							showMoreText={section.showMoreText}
							searchEnabled={section.searchEnabled}
							placeholder={section.placeholderText}
						/>
					</>
				)}
			</Section>
			{sectionsLength - 1 !== index && <Divider className='my-15 my-11--xs' /> }
		</>
	);
}

export default SectionBlock;
